<template>
    <div v-if="soilsamplers.length > 0" class="my-4">
        <div class="overflow-x-auto pb-20 shadow border-b border-gray-200">
            <table
                class="table-auto min-w-full divide-y divide-gray-400 border-b border-gray-400 border-collapse rounded-lg"
            >
                <thead>
                    <tr class="bg-gray-200 font-bold text-sm text-gray-900">
                        <td class="px-1 py-2.5">
                            Name
                        </td>
                        <td class="px-1 py-2.5">
                            Email
                        </td>
                        <td class="px-1 py-2.5">
                            Telephone
                        </td>
                    </tr>
                </thead>

                <tbody class="bg-white overflow-y-auto">
                    <tr class="odd:bg-white even:bg-slate-100 text-gray-900 text-sm"
                        v-for="(sampler, index) in soilsamplers"
                        :key="index"
                    >
                        <td class="px-1 py-2.5">
                            {{ sampler.name }}
                        </td>
                        <td class="px-1 py-2.5">
                            {{ sampler.email }}
                        </td>
                        <td class="px-1 py-2.5">
                            {{ sampler.telephone }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div v-if="soilsamplers.length === 0" class="bg-white px-6 py-4 my-4">
        <strong>No soil samplers found.</strong>
    </div>
</template>

<script>
export default {
    props: {
        soilsamplers: Object,
    },
};
</script>
